import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../tooltip';

interface GrayTooltipProps {
  children: React.ReactNode;
  message: string | JSX.Element;
  hidden?: boolean;
}

export const GrayTooltip = ({ children, message, hidden = false }: GrayTooltipProps) => {

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <span className='inline-flex'>{children}</span>
        </TooltipTrigger>
        <TooltipContent
          hidden={hidden}
          className='border-none bg-[#232426] text-white text-xs shadow-lg rounded px-2 max-w-[250px]'
        >
          <p className="whitespace-normal text-center">
            {message}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
